import { connect } from 'react-redux';
import React, { Component } from "react";
import ReactTable from "react-table";
import { Card, CardBody, CardHeader, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { PanelHeader } from "components";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import { loopbackActions } from 'actions';
import ErrorModal from "../Components/ErrorModal"
import Clearfix from "../../components/Custom/Clearfix";
import { selectedProjectChangeListeners } from '../../components/Header/Header';
import { withTranslation } from 'react-i18next';
import packageJson from '../../../package.json';


class Info extends Component {

  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      error: null
    }


  }





  render() {

    const { error } = this.state;
    
    const { t } = this.props;

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle>
                      Umpi X-Perience
                    <Clearfix />
                  </CardTitle>
                </CardHeader>
                <CardBody>
                      <h6 style={{ fontWeight: "bold" }}> Ver. {packageJson.version}</h6>
                </CardBody>
                <CardFooter>
                <p>&copy; 2019 Umpi</p>
                </CardFooter>
              </Card>



            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, loopback } = state;
  return {
    authentication,
    drivers: loopback.drivers
  };
}

const connectedInfo = withTranslation()(connect(mapStateToProps)(Info));
export { connectedInfo as Info }; 


// WEBPACK FOOTER //
// ./src/views/Info/Info.jsx